import { render } from "./ViewAllSubResource.vue?vue&type=template&id=c3b1a356"
import script from "./ViewAllSubResource.vue?vue&type=script&lang=js"
export * from "./ViewAllSubResource.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__